import { AmrapRecap } from "@modules/sessionBlock/exercises/components/RecapDetailAllChronos/amrapRecap"
import { EmomRecap } from "@modules/sessionBlock/exercises/components/RecapDetailAllChronos/emomRecap"
import { FortimeRecap } from "@modules/sessionBlock/exercises/components/RecapDetailAllChronos/fortimeRecap"
import { TabataRecap } from "@modules/sessionBlock/exercises/components/RecapDetailAllChronos/tabataRecap"
import { ExerciseFormikType } from "@modules/sessionBlock/exercises/exerciseFormikTypes"
import { useSessionFormContext } from "@modules/sessions/hooks/useSessionFormContext"

export const ChronoRecap: React.FC = () => {
  const { formik, updatedBlockIndex } = useSessionFormContext()

  if (updatedBlockIndex === null) return <></>

  const formikValue = formik.values.blocks[updatedBlockIndex].content as ExerciseFormikType

  return (
    <div className="w-full flex flex-column py-2 px-3 card mb-2">
      {formikValue.chronoAmrap && <AmrapRecap />}
      {formikValue.chronoEmom && <EmomRecap />}
      {formikValue.chronoTabata && <TabataRecap />}
      {formikValue.chronoForTime && <FortimeRecap />}
    </div>
  )
}
